import { PaymentMethod } from "@omni/types/components/payment/paymentMethod.model";
import { cn } from "@omni/utils/styles";

import { PaymentMethodsConfig } from "@/components/Checkout/Payment/paymentMethods/paymentMethod/paymentMethods.config";
import { RedirectPaymentComponent } from "@/components/Checkout/Payment/paymentMethods/paymentMethod/redirectPayment/redirectPayment.component";
import { SelectableCardField } from "@/components/Form/RHF/FormFields/SelectableCardField/selectableCardField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { DamImage } from "@/utils/dam.utils";

import { PaymentMethodsFormValues } from "../../payment.schema";

type Props = {
    method: PaymentMethod;
};

export const PaymentMethodComponent = ({ method }: Props) => {
    const { t } = useGranite();

    const translatedMethodName = t(
        `checkout.psp.paymentMethods.name.${method.code}`
    );
    const methodName = translatedMethodName
        ? translatedMethodName
        : method.name;

    const microCopy = t(`checkout.psp.paymentMethods.microcopy.${method.code}`);

    return (
        <Row className="mb-3">
            <Col>
                <SelectableCardField<PaymentMethodsFormValues>
                    label={""}
                    required={false}
                    value={method.code}
                    name={"code"}
                >
                    {({ isActive }) => (
                        <>
                            <div className="py-1 d-flex align-items-center">
                                <img
                                    key={method.code}
                                    src={DamImage.icon.payment[method.code]}
                                    alt={methodName}
                                    width={35}
                                    className={"mr-3"}
                                />
                                <div
                                    className={cn(
                                        "d-flex align-items-center flex-wrap",
                                        {
                                            "font-weight-bold": isActive
                                        }
                                    )}
                                >
                                    <span className={"mr-2"}>{methodName}</span>
                                    {microCopy && (
                                        <span
                                            className={
                                                "small font-weight-light d-block d-md-inline"
                                            }
                                        >
                                            ({microCopy})
                                        </span>
                                    )}
                                </div>
                            </div>
                            {isActive &&
                                (PaymentMethodsConfig.componentMap[
                                    method.code
                                ] ?? (
                                    <RedirectPaymentComponent
                                        code={method.code}
                                    />
                                ))}
                        </>
                    )}
                </SelectableCardField>
            </Col>
        </Row>
    );
};
